module.exports = __webpack_public_path__ + "img/topImg-4-m.19907ba9.png";